import {Component} from "@angular/core";

@Component({
    selector: "fui-fields",
    styleUrls: ["./fields.component.scss"],
    templateUrl: "./fields.component.html",
    standalone: false
})
export class FUIFieldsComponent {
}
